import React from "react";
import { useTranslation } from "react-i18next";
import { LocaleLink } from "../../i18n/LocaleLink";

export const FeatureThreeItem = ({ feature }) => {
  const { t } = useTranslation();

  return (
    <div className="features-item-three">
      <div className="features-icon-three">
        <i className="flaticon-inspiration"></i>
      </div>
      <div className="features-content-three">
        <h2 className="title">{feature.title}</h2>
        <p>{feature.subtitle}</p>
        <LocaleLink
          to={feature.href}
          state={{ serviceId: feature.id }}
          className="link-btn"
        >
          {t("common.learnMore")} <img src={feature.src} alt="" />
        </LocaleLink>
      </div>
    </div>
  );
};
